var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWethe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9677 3.38L12.8359 3.81666V16.4863L12.9677 16.6146L18.9972 13.1383L12.9677 3.38Z",
    fill: "#C1CCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9633 3.38L6.93359 13.1383L12.9633 16.6146V10.4651V3.38Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.962 17.7278L12.8877 17.8161V22.3293L12.962 22.5408L18.9952 14.2533L12.962 17.7278Z",
    fill: "#C1CCF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9633 22.5408V17.7278L6.93359 14.2533L12.9633 22.5408Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9609 16.6145L18.9904 13.1382L12.9609 10.465V16.6145Z",
    fill: "#8198EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93359 13.1382L12.9633 16.6145V10.465L6.93359 13.1382Z",
    fill: "#C1CCF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWethe);
export default __webpack_public_path__ + "static/media/weth.e.14de6a79ad3554608fdcc109b17351a4.svg";
export { ForwardRef as ReactComponent };